import React from 'react';

const SearchHeader = () => {
  return (
    <h1>Search</h1>
  );
};

export default SearchHeader;
